import flowMergedLanguage from "@mittwald/flow-components/dist/i18n/de";
import mergedDeLanguage from "./merged/de.json";
export default {
    ...flowMergedLanguage,
    ...mergedDeLanguage,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaTE4bi9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLGtCQUFrQixNQUFNLHdDQUF3QyxDQUFDO0FBQ3hFLE9BQU8sZ0JBQWdCLE1BQU0sa0JBQWtCLENBQUM7QUFFaEQsZUFBZTtJQUNiLEdBQUcsa0JBQWtCO0lBQ3JCLEdBQUcsZ0JBQWdCO0NBQ3BCLENBQUMifQ==